export const NAVIGATE_DATA_SET = 'NAVIGATE_DATA_SET';